import { Modify } from "../utilities/modifyType";
import { AssetCategory, toAssetCategory } from "./AssetCategory";

export interface ShareItem {
    id: number,
    name: string,
    category: AssetCategory;
    enabled: boolean;
    commentsEnabled: boolean;
    videoPath?: string;
    assetShareType: AssetShareType;
    views: number;
    slug: string;
}

export enum AssetShareType {
    YouTube = 0,
    Vimeo,
    Facebook,
    None,   
}

export type serializedShareItem = Modify<ShareItem, {
    category: string,
}>

export const deserializeShareItem = (shareItem:serializedShareItem): ShareItem => {
    return {
        ...shareItem,
        category: toAssetCategory(shareItem.category),
    }
}